export default "__VITE_ASSET__BEpuO80o__"